<now-wbsuche-lib-suche (zeigeDetailseite)="zeigeDetailseite($event)"></now-wbsuche-lib-suche>
